<template>
<div>
<Navbar />


<!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_login_page_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="login-page-top-im-title"> my<span style="color: #2eca8b">Account</span> </h4>
                <p class="login-page-top-im-ptext">Reset Password</p>
                
                <div class="page-next"></div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->



  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluids"
      :class="{
        'login-signin-on': this.state == 'signin',
      }"
      id="kt_login"
    >
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto "
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <form
              class="form r_login_p_form_p"
              novalidate="novalidate"
              id="kt_login_signin_form"
              @submit.stop.prevent="onSubmitResetPassword()"
            >
            <input type="hidden" name="token" v-model="form.token" ref="token" />
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Your email address <span class="text-danger">*</span></label>
                <div id="example-input-group-1" label="" label-for="example-input-1">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                    type="text"
                    name="email"
                    placeholder="Email"
                    ref="email"
                    v-model="form.email"
                    disabled
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="d-flex justify-content-between mt-n5">
                  <label class="font-size-h6 text-dark pt-5 r_login_p_lbl"
                    >Password <span class="text-danger">*</span></label
                  >
                </div>
                <div id="example-input-group-2" label="" label-for="example-input-2">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                    type="password"
                    name="password"
                    placeholder="Password"
                    ref="password"
                    v-model="form.password"
                    autocomplete="off"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Confirm Password <span class="text-danger">*</span></label>
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                  type="password"
                  placeholder="Confirm password"
                  name="cpassword"
                  ref="cpassword"
                  autocomplete="off"
                />
              </div>
              <span class="text-danger" v-if="loginError && loginError.length"> {{loginError}} </span>
              <div class="pb-lg-0 pb-5 text-center">
                <button
                  ref="kt_forgot_password_submit"
                  class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 r_lgn_p_signin_btn"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
          <!--end::Signin-->
        </div>
        <!--begin::Content footer-->
        <div
          class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0 r_lgn_p_trms_div"
        >
        <a href="/terms-and-conditions" class="text-primary font-size-h5 r_lgn_p_trms_a">Terms</a>
          <a href="/university/plans" class="text-primary ml-10 font-size-h5 r_lgn_p_trms_a r_lgn_p_plns">Plans</a>
          <a href="/contact" class="text-primary ml-10 font-size-h5 r_lgn_p_trms_a"
            >Contact Us</a
          >
        </div>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->

      
    </div>
  </div>
  <Footer />
</div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

import Navbar from "@/view/front/components/navbar";
import Footer from "@/view/front/components/footer";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import IndexService from "@/MainServices/IndexService.js";
import Swal from "sweetalert2";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      fv: "",
      // Remove this dummy login info
      form: {
        email: "",
        token: "",
        password: "",
      },
      user_role: null,
      signInFormClass: 'active',
      signUpFormClass: '',
    };
  },
  components: {
    Navbar,
    Footer
  },
  computed: {
    loginError() {
      return this.$store.state.auth.errors;
    },
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg";
    },
  },
  mounted() {
    const signup_form = KTUtil.getById("kt_login_signin_form");
    this.form.email = this.$route.query.email;
    this.form.token = this.$route.query.token;


    this.fv = formValidation(signup_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required",
            },
            identical: {
              compare: function () {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    if (this.currentUser && this.currentUser.role == "admin") {
      this.$router.push({ name: "dashboard" });
    }
    if (this.currentUser && this.currentUser.role == "institute") {
      this.$router.push({ name: "institute-dashboard" });
    }
    if (this.currentUser && this.currentUser.role == "student") {
      this.$router.push({ name: "student-dashboard" });
    }
  },
  methods: {
    showForm(form) {
      this.loginError = "";
      this.state = form;

      if(form == 'signin'){
        this.signInFormClass = 'active';
        this.signUpFormClass = '';
      }
      else if(form == 'signup') {
        this.signInFormClass = '';
        this.signUpFormClass = 'active';
      }
      
      // var form_name = "kt_login_" + form + "_form";
      // KTUtil.animateClass(
      //   KTUtil.getById(form_name),
      //   "animate__animated animate__backInUp"
      // );
    },

    onSubmitResetPassword() {

      let send = 'yes';

      if(this.$store.state.auth.errors)
      {
        send = 'no';
      }
        

      this.fv.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });


      this.fv.on("core.form.valid", () => {
        const token = this.$refs.token.value;
        const email = this.$refs.email.value;
        const password = this.$refs.password.value;
        const cpassword = this.$refs.cpassword.value;
        // clear existing errors
        // this.$store.dispatch(LOGOUT);
        // set spinner to submit button
        const submitButton = this.$refs["kt_forgot_password_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        if(send == 'yes') {

            IndexService.ResetPassword(token,email,password,cpassword).then((res)=> {
                send = 'no';
                Swal.fire({
                title: "",
                icon: "success",
                html: "Password updated! you can login now" + "<a href='/login'><button class='btn btn-primary'>Login</button></a>",
                showCancelButton: false,
                showConfirmButton: false,
                heightAuto: false,
                });
            }).catch((error) => {
                send = 'no';
                Swal.fire({
                    title: "",
                    text: "Your token is expired! Please try again",
                    icon: "error",
                    confirmButtonClass: "btn btn-secondary",
                    heightAuto: false,
                });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.fv-plugins-message-container {
  margin-left: 10px !important;
}
</style>
